<template>
  <div class="signup">
    <form @submit.prevent='onSubmit'>
      <div v-if="!isCreating">
        <input type="text" v-model="userName" class="signup_textField" placeholder="ニックネームの入力"/>
        <div @click="onSubmit" class="signup_button">チャットに参加する</div>
      </div>
      <div v-else>
        <loading class="message_loading" :show="true"/>
      </div>
    </form>
  </div>
</template>

<script>
import store from '@/store/index'
import Loading from '@/components/Loading'

export default {
  name: 'Signup',
  data () {
    return {
      userName: '',
    }
  },
  methods: {
    onSubmit: function(){
      store.dispatch('signup', { name: this.userName })
    }
  },
  computed: {
    currentAccount: function(){
      return store.getters.currentAccount
    },
    isCreating: function(){
      return store.getters.currentIsCreating
    }
  },
  components: {
   'loading': Loading
  },
}
</script>

<style scoped>
.signup {

}

.signup_textField {
  display: block;
  width: 85%;
  margin: 0 auto;
  border: 1px solid #ccc;
  padding: 10px 5px;
  font-size: 16px;
  resize: none;
  outline: none;
  margin-bottom: 20px;
}

.signup_button {
  cursor: pointer;
  display: inline-block;
  padding: 10px;
  background-color: #ff606d;
  border-radius: 5px;
  color: white;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Signup.vue